export const CARDANO_NATIVE_ADDRESS = 'lovelace';
